import { render } from "./cp_number.vue?vue&type=template&id=9b8b62de&scoped=true"
import script from "./cp_number.vue?vue&type=script&lang=js"
export * from "./cp_number.vue?vue&type=script&lang=js"

import "./cp_number.vue?vue&type=style&index=0&id=9b8b62de&scoped=scoped&lang=less"

import exportComponent from "E:\\Project\\HZY\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b8b62de"]])

export default __exports__